import React from 'react';
import Landing from '../Landing/Landing';
import Home from '../Home/Home';
import Spa from '../../components/Spa/Spa';
import Main from '../Main/Main';
import Snippet from '../Snippet/Snippet';
import SnippetDetailPage from '../SnippetDetailPage/SnippetDetailPage';  // Import the SnippetDetailPage component
import { Route, Routes } from 'react-router-dom';

import Bottombar from '../../components/Bottombar/Bottombar';
import Navbar from '../../components/Navbar/Navbar';
import './AppRoute.css';

const AppRoute = () => {
  return (
    <div className='app-outer-wrapper'>
      <Navbar />
      <Routes>
        <Route path='/' element={<Landing />} />
        <Route path='/home' element={<Home />} />
        <Route path='/spa' element={<Spa />} />
        <Route path='/snippet' element={<Snippet />} />
        <Route path="/snippet/:id" element={<SnippetDetailPage />} />
        <Route path="/*" element={<Main />} />
      </Routes>
      
      <Bottombar />
    </div>
  );
};

export default AppRoute;
